import { createContext } from 'react';

export type ReworkRecordContextProps = {
  footerSlotName?: string;
};

export const ReworkRecordContext = createContext<ReworkRecordContextProps>(
  null as any,
);
